import { useEffect, useRef } from "react";
import { TileLayer, Marker, Popup, LayersControl, LayerGroup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-easybutton";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import youAreHere from "src/img/maps/youAreHere.png";
import truck from "src/img/maps/truck.png";
import truckrun from "src/img/maps/truckrun.png";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    projectCategoryColorCode,
    restDayProjectHashKey,
    getBrandLogo
} from "src/components/common/functions";
import MapSize from "./mapSize";
import CustomMarker from "./customMarker";
//--------------------------------------------------------------------------------------------
export default function Maps({
    geoData, 
    mapFull, 
    workInstructions, 
    workLogs, 
    history, 
    path1, 
    path2, 
}){
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const map = useMap();
    //--------------------------------------------------------------------------------------------
    const truckicon = L.icon({
        iconUrl: truck,
        iconSize: [45, 45]
    });
    const truckrunicon = L.icon({
        iconUrl: truckrun,
        iconSize: [45, 45]
    });
    const youAreHereIcon = L.icon({
        iconUrl: youAreHere,
        iconSize: [45, 45]
    });
    const projects = Object.entries(projectCategoryColorCode).map(([key, value]) => ({
        name: value.title, 
        category: key, 
        icon: value.icon
    }));
    const thisWatermark = useRef(null);
    const easyButton1 = useRef(null);
    useEffect(() => {
        if(map){
            const scale = L.control.scale();
            map.addControl(scale);
        }
    }, [map])
    useEffect(() => {
        if(!thisWatermark.current && map){
            L.control.watermark = opts => {
                return new L.Control.Watermark(opts);
            }
            L.Control.Watermark = L.Control.extend({
                onAdd: () => {
                    const img = L.DomUtil.create("img");
                    img.src = getBrandLogo();
                    return img;
                }
            });
            thisWatermark.current = L.control
            .watermark({ position: "bottomright" })
            .addTo(map);
        }
        if(!easyButton1.current && map){
            easyButton1.current = L.easyButton(`<span>✎</span>`, (btn, map) => {
                window.alert("pen");
                //const currfile = winow.prompt("New drawing name: ");
                // if(currfile === null) return;
                // if(currfile === ""){
                //     window.alert("Name is required to void.");
                //     return;
                // }
                //const editableLayers = new L.FeatureGroup();
                //L.layerControl.addOverlay(editableLayers, currfile);
                //map.addLayer(editableLayers);
            },"pen").addTo(map);
            L.easyButton(`<span>★</span>`, (btn, map) => {
                window.alert("star");
            },"star").addTo(map);
        }
    }, [map]);
    useEffect(() => {
        // Wait for the DOM to update
        const checkboxes = document.querySelectorAll(".leaflet-control-layers-selector");
        checkboxes.forEach((checkbox, index) => {
          checkbox.id = `layer-checkbox-${index}`; // Assigns unique ID
        });
      }, []);
    //--------------------------------------------------------------------------------------------
    return(
        <>
            <MapSize mapFull = {mapFull}/>
            <LayersControl position = "topright">
                <LayersControl.BaseLayer checked name = "Google Maps">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Satellite">
                    <TileLayer
                        attribution = ""
                        url = "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Satellite Hybrid">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Terrain">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Roads">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Open Street Map">
                    <TileLayer
                        attribution = ""
                        url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                {false?
                <LayersControl.BaseLayer name = "Black And White">
                    <TileLayer
                        attribution = ""
                        url = "https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                :<></>}
                <LayersControl.Overlay name = "You are here" checked>
                    <Marker position = {user.coords} icon = {youAreHereIcon}>
                        <Popup>
                            your current location
                        </Popup>
                    </Marker>
                </LayersControl.Overlay>
                <LayersControl.Overlay name = "Trucks" checked = {true || geoData.map(e => e.name).includes(path2)}>
                    <LayerGroup>
                        {geoData.map((e, i) => 
                        <CustomMarker key = {i}
                            position = {[
                                e.eventData?.latitude ?? 0, 
                                e.eventData?.longitude ?? 0
                            ]}
                            icon = {e.eventData?.isDriving?truckicon:truckrunicon}
                            isActive = {path2 === e.name}
                            hash = {e.name}
                            map = {map}
                            history = {history}
                            path1 = {path1}
                        >
                            <br/>
                            <div className = "leaflet-popup-title">ID: {e.id}</div>
                            <div className = "py-1">
                                <span className = "font-weight-bold mr-1">Name:</span>
                                <Link to = {`/Fleets/${e.name}`}>{e.name}</Link>
                            </div>
                        </CustomMarker>
                        )}
                    </LayerGroup>
                </LayersControl.Overlay>
                {projects.map((v, k) => 
                <LayersControl.Overlay checked key = {k} name = {v.name}>
                    <LayerGroup>
                        {workInstructions
                        .filter(w => w.projectHashKey !== restDayProjectHashKey)
                        .map((w, i) => w.coords && w.category === v.category?
                        <CustomMarker
                            key = {i} 
                            position = {[
                                parseFloat(w.coords?.split(",")[0] ?? 0), 
                                parseFloat(w.coords?.split(",")[1] ?? 0)
                            ]} 
                            icon = {
                                L.icon({
                                    iconUrl: v.icon,
                                    iconSize: [45, 45]
                                })
                            }
                            isActive = {path2 === w.workInstructionHashKey}
                            hash = {w.workInstructionHashKey}
                            map = {map}
                            history = {history} 
                            path1 = {path1}
                        >
                            <div className = "leaflet-popup-title">{v.category}</div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Project Name:</span>
                                <Link className = "forLink" to = {
                                    `/Projects/${w.projectHashKey}/WorkInstructions/${w.workInstructionHashKey}`
                                }>
                                    {w.projectName}
                                </Link>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Project Manager:</span>
                                <UserInfo name = {w.projectManager} email = {w.projectManagerEmail}/>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Project Creator:</span>
                                <UserInfo name = {w.projectCreator} email = {w.projectCreatorEmail}/>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Work Instruction Creator:</span>
                                <UserInfo name = {w.workInstructionCreator} email = {w.workInstructionCreatorEmail}/>
                            </div>
                            {w.workInstructionUpdaterEmail?
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Work Instruction Creator:</span>
                                <UserInfo name = {w.workInstructionUpdater} email = {w.workInstructionUpdaterEmail}/>
                            </div>
                            :<></>}
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Location:</span>
                                <a href = {`http://google.com/maps?q=${w.location}`} target = "_blank" rel = "noreferrer">
                                    {w.location}
                                </a>
                            </div>
                            <div className = "pt-2 lineHeight15"> 
                                <span className = "font-weight-bold mr-1">
                                    Time:
                                </span>
                                {w.allDay?
                                <>
                                    {w.startTime.substring(0, 10)}
                                    {w.startTime.substring(0, 10) === w.endTime.substring(0, 10)?
                                    null:` ~ ${w.endTime.substring(0, 10)}`}
                                </>
                                :
                                <>
                                    <>{w.startTime.substring(0, 10)}</> 
                                    <>
                                        {w.startTime.substring(10, 19)}
                                    </> 
                                    ~ 
                                    <>
                                        {w.startTime.substring(0, 10) === w.endTime.substring(0, 10)?
                                        null:w.endTime.substring(0, 10)}
                                    </>
                                    <>
                                        {w.endTime.substring(10, 19)}
                                    </>
                                </>
                                }
                            </div>
                            {w.workInstructionFiles.length?
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Work Instruction Files:</span>
                                {w.workInstructionFiles.map((p, key) => <li key = {key} className = "pt-2">
                                    <a href = {p.webViewLink} target = "_blank" rel = "noreferrer">
                                        {p.name}
                                    </a>
                                </li>)}
                            </div>
                            :<></>}
                            <div className = "pt-2 lineHeight15">
                                <span className = "font-weight-bold mr-1">Technicians:</span>
                                {workLogs.filter(wl => wl.hashKey === w.workInstructionHashKey).map((wl, key) => <li key = {key} className = "m-2"><UserInfo email = {wl.email} name = {wl.name}/></li>)}
                            </div>
                        </CustomMarker>:null
                        )}
                    </LayerGroup>
                </LayersControl.Overlay>
                )}
            </LayersControl>
        </>
    )
}
